/* eslint-disable react/no-unused-prop-types */
import isFunction from 'lodash/isFunction';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SHGlobals from 'sh-globals';

export default EnhancedComponent => {
    class Config extends Component {
        getWrappedInstance() {
            if (isFunction(this._wrappedInstance.getWrappedInstance)) {
                // check to see if this is also wrapped by connect and if so get that instance instead
                // for this to work your connect has to have withRef
                // connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})
                return this._wrappedInstance.getWrappedInstance();
            } else {
                return this._wrappedInstance;
            }
        }

        render() {
            return (
                <EnhancedComponent
                    {...this.props}
                    cloudinary={SHGlobals.cloudinary}
                    isProduction={SHGlobals.isProduction}
                    isAdmin={SHGlobals.isAdmin}
                    isMobile={SHGlobals.isMobile}
                    useNativeDatePicker={SHGlobals.useNativeDatePicker}
                    currentCityDateTime={SHGlobals.currentCityDateTime}
                    currentCityTimezone={SHGlobals.currentCityTimezone}
                    ref={node => { this._wrappedInstance = node; }}
                />
            );
        }
    }

    Config.propTypes = {
        apiPath: PropTypes.string,
        serviceApiPath: PropTypes.string,
        staticPath: PropTypes.string,
        urlDateFormat: PropTypes.string,
        urlTimeFormat: PropTypes.string,
        mobileDateFormat: PropTypes.string,
        desktopDateFormat: PropTypes.string,
        mobileTimeFormat: PropTypes.string,
        desktopTimeFormat: PropTypes.string,
        serverDateTimeFormat: PropTypes.string,
        facilityIncludes: PropTypes.string,
        acceptedCreditCards: PropTypes.arrayOf(PropTypes.string),
        isProduction: PropTypes.bool,
        isAdmin: PropTypes.bool,
        isMobile: PropTypes.bool,
        useNativeDatePicker: PropTypes.bool,
        currentCityDateTime: PropTypes.string,
        currentCityTimezone: PropTypes.string,
        initPaymentProcessor: PropTypes.func,
        cloudinary: PropTypes.object,
        cloudinaryTransformations: PropTypes.func
    };

    Config.defaultProps = {
        apiPath: SHGlobals.API_PATH,
        serviceApiPath: SHGlobals.SERVICE_API_PATH,
        staticPath: SHGlobals.STATIC_PATH,
        urlDateFormat: SHGlobals.URL_DATE_FORMAT,
        urlTimeFormat: SHGlobals.URL_TIME_FORMAT,
        mobileDateFormat: SHGlobals.MOBILE_DATE_FORMAT,
        desktopDateFormat: SHGlobals.DESKTOP_DATE_FORMAT,
        mobileTimeFormat: SHGlobals.MOBILE_TIME_FORMAT,
        desktopTimeFormat: SHGlobals.DESKTOP_TIME_FORMAT,
        serverDateTimeFormat: SHGlobals.SERVER_DATE_TIME_FORMAT,
        facilityIncludes: SHGlobals.FACILITY_INCLUDES,
        acceptedCreditCards: SHGlobals.ACCEPTED_CREDIT_CARDS,
        isProduction: SHGlobals.isProduction,
        isAdmin: SHGlobals.isAdmin,
        isMobile: SHGlobals.isMobile,
        useNativeDatePicker: SHGlobals.useNativeDatePicker,
        currentCityDateTime: SHGlobals.currentCityDateTime,
        currentCityTimezone: SHGlobals.currentCityTimezone,
        cloudinary: null,
        initPaymentProcessor: SHGlobals.initPaymentProcessor,
        cloudinaryTransformations: SHGlobals.cloudinaryTransformations
    };

    return Config;
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/global/common/Config.jsx